export default class MessageModel {
  constructor({ chat_id, content, user_id, id }) {
    this.chat_id = chat_id;
    this.user_id = user_id;
    this.content = content;
    this.id = id;
  }
}
